<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('enrollment_information') }}</h5>
        <b-card class="soft mb-5">
            <b-row>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_semester') }}</label>
                        <div>
                            <span>{{ getObjectValue(studentProgram, 'registration_semester_academic_year') }} </span>
                            <span>&nbsp;-&nbsp;</span>
                            <span>{{ studentProgram.registration_semester ? studentProgram.registration_semester: '-' }}</span>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_date') }}</label>
                        <div>{{ studentProgram.registration_date ? this.toLocaleDate(studentProgram.registration_date) : '-' }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_type') }}</label>
                        <div>{{ studentProgram.registration_type_text ? studentProgram.registration_type_text : '-' }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('student_status') }}</label>
                        <div>{{ studentProgram.student_status_text }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('semester_status') }}</label>
                        <div>{{ studentProgram.semester_status_name }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('number_of_semesters') }}</label>
                        <div>{{ studentProgram.from_number_of_semesters }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('number_of_semesters_studied') }}</label>
                        <div>{{ studentProgram.number_of_semester }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('semester_count') }}</label>
                        <div>{{ studentProgram.semester_count }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('max_duration') }}</label>
                        <div>{{ studentProgram.max_duration }}</div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-row v-if="user.active_student_program?.student_status!='101'">
            <b-col cols="12" lg="6">
                <b-card :header="$t('graduation_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('graduation_semester') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'graduation_semester_academic_year','') }}
                                    -
                                    {{ studentProgram.graduation_semester_semester ? studentProgram.graduation_semester_semester : '' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('graduation_decision_date') }}</label>
                                <div>{{ studentProgram.graduation_date ? this.toLocaleDate(studentProgram.graduation_date) : '-' }}</div>
                            </div>
                        </b-col>
<!--                        <b-col cols="6" lg="12">-->
<!--                            <div class="label-as-input-div">-->
<!--                                <label>{{ $t('graduation_decision_number') }}</label>-->
<!--                                <div>{{ getObjectValue(studentProgram, 'graduation_decision_number') }}</div>-->
<!--                            </div>-->
<!--                        </b-col>-->
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('diploma_information')" class="soft mb-5">
                    <b-row>

                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('thesis_title') }}</label>
                                <div>{{ studentProgram.thesis_title }}</div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_status') }}</label>
                                <div>{{ studentProgram.diploma_status_name }}</div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_date') }}</label>
                                <div>{{ studentProgram.diploma_date ? this.toLocaleDate(studentProgram.diploma_date) : '-' }}</div>
                            </div>
                        </b-col>

<!--                        <b-col cols="6" lg="12">-->
<!--                            <div class="label-as-input-div">-->
<!--                                <label>{{ $t('diploma_status') }}</label>-->
<!--                                <div>{{ studentProgram.diploma_status_name }}</div>-->
<!--                            </div>-->
<!--                        </b-col>-->
<!--                        <b-col cols="6" lg="12">-->
<!--                            <div class="label-as-input-div">-->
<!--                                <label>{{ $t('diploma_date') }}</label>-->
<!--                                <div>{{ studentProgram.diploma_date ? this.toLocaleDate(studentProgram.diploma_date) : '-' }}</div>-->
<!--                            </div>-->
<!--                        </b-col>-->

                        <!--
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_supplement') }}</label>
                                <div>-</div>
                            </div>
                        </b-col>
                        -->
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_number') }}</label>
                                <div>{{ getObjectValue(studentProgram, 'diploma_number') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('leaving_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('reason_for_leaving') }}</label>
                                <div>
                                    {{ studentProgram.leaving_reason_name }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_semester') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'leaving_semester_academic_year','') }}
                                    -
                                    {{ studentProgram.leaving_semester_semester ? studentProgram.leaving_semester_semester : '' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_date') }}</label>
                                <div>{{ studentProgram.leaving_date ? this.toLocaleDate(studentProgram.leaving_date) : '-' }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_update') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal" size="xxl"
                     :onHideOnlyX="true"
                     @bHideModalHeaderClose="clearFormData()"
                     v-if="checkPermission('studentprogram_update') && editMode">
            <template v-slot:CommonModalTitle>
                {{ changeText($t('edit')) }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Update Form
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        computed:{
            user() {
                return this.$store.getters["auth/getUser"];
            },

        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

